import { useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { templateKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
/**
 * Real fetchList/fetchDetail for useDripTemplateSession. staleTime: 0 forces
 * an actual network round trip on every call regardless of what's already
 * cached — an inactive or invalidated-but-unobserved query can't hand back
 * a "success" that never really happened for this call. queryClient's
 * fetchQuery (unlike invalidateQueries) rejects when the request fails, and
 * still writes a successful result into the same keys useMarkTemplates/
 * useMarkTemplate read, so the StepCanvas channel lock keeps seeing fresh
 * data without owning any part of this resolution itself.
 */
const useDripTemplateSessionTransport = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return {
        fetchList: async (dripId, versionNumber) => {
            const parent = {
                drip_id: dripId,
                ...(versionNumber != null ? { version_number: versionNumber } : {})
            };
            const response = await queryClient.fetchQuery({
                queryKey: templateKeys.rows(parent),
                queryFn: () => axios.get(markUrl('mark-templates/list/'), {
                    ...additional,
                    params: parent
                }),
                staleTime: 0
            });
            return response.data.templates;
        },
        fetchDetail: async (templateId) => {
            const response = await queryClient.fetchQuery({
                queryKey: templateKeys.row(templateId),
                queryFn: () => axios.get(markUrl('mark-templates/detail/'), {
                    ...additional,
                    params: { id: templateId }
                }),
                staleTime: 0
            });
            return response.data;
        }
    };
};
export default useDripTemplateSessionTransport;
